module.exports = __webpack_public_path__ + "img/icon-firefox.2846f97d.svg";